webpackJsonp([198517197184460],{

/***/ 100:
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(178);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(13);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(57);
	
	var assertThisInitialized = __webpack_require__(100);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(15));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(13));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(28));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (childrenProp) {
	    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react.default.isValidElement(childrenProp)) {
	      var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	      children = _react.default.cloneElement(childrenProp, {
	        className: childrenClassName
	      });
	    } else {
	      children = childrenProp;
	    }
	  } else if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Attributes applied to the `img` element when the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(179));

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertHexToRGB = convertHexToRGB;
	exports.rgbToHex = rgbToHex;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	//  weak
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;
	
	  if (value < min) {
	    return min;
	  }
	
	  if (value > max) {
	    return max;
	  }
	
	  return value;
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function convertHexToRGB(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb(".concat(colors.map(function (n) {
	    return parseInt(n, 16);
	  }).join(', '), ")") : '';
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Pass hex straight through
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  function intToHex(c) {
	    var hex = c.toString(16);
	    return hex.length === 1 ? "0".concat(hex) : hex;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  values = values.map(function (n) {
	    return intToHex(n);
	  });
	  return "#".concat(values.join(''));
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  if (false) {
	    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
	    }
	  }
	
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  }
	
	  if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(color.type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  var decomposedColor = decomposeColor(color);
	
	  if (decomposedColor.type.indexOf('rgb') !== -1) {
	    var rgb = decomposedColor.values.map(function (val) {
	      val /= 255; // normalized
	
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    }); // Truncate at 3 digits
	
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	  } // else if (decomposedColor.type.indexOf('hsl') !== -1)
	
	
	  return decomposedColor.values[2] / 100;
	}
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
	  if (!color) return color;
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
	  if (!color) return color;
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
	  if (!color) return color;
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end) + 1;
	
	    if (endIndex === keys.length) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _objectSpread2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	/* eslint-disable no-underscore-dangle */
	// People might bundle this classname generator twice.
	// We need to use a global.
	global.__MUI_GENERATOR_COUNTER__ = 0;
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	
	function safePrefix(classNamePrefix) {
	  var prefix = String(classNamePrefix);
	   false ? (0, _warning.default)(prefix.length < 100, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.
	
	  return prefix.replace(escapeRegex, '-');
	} // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
	      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr;
	  var ruleCounter = 0; // - HMR can lead to many class name generators being instantiated,
	  // so the warning is only triggered in production.
	  // - We expect a class name generator to be instantiated per new request on the server,
	  // so the warning is only triggered client side.
	
	  if (("production") === 'production' && typeof window !== 'undefined') {
	    global.__MUI_GENERATOR_COUNTER__ += 1;
	
	    if (global.__MUI_GENERATOR_COUNTER__ > 2) {
	      // eslint-disable-next-line no-console
	      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
	    }
	  }
	
	  return function (rule, styleSheet) {
	    ruleCounter += 1;
	     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0; // Code branch the whole block at the expense of more code.
	
	    if (dangerouslyUseGlobalCSS) {
	      if (styleSheet && styleSheet.options.classNamePrefix) {
	        var prefix = safePrefix(styleSheet.options.classNamePrefix);
	
	        if (prefix.match(/^Mui/)) {
	          return "".concat(prefix, "-").concat(rule.key);
	        }
	
	        if (false) {
	          return "".concat(prefix, "-").concat(rule.key, "-").concat(ruleCounter);
	        }
	      }
	
	      if (true) {
	        return "".concat(productionPrefix).concat(ruleCounter);
	      }
	
	      return "".concat(rule.key, "-").concat(ruleCounter);
	    }
	
	    if (true) {
	      return "".concat(productionPrefix).concat(ruleCounter);
	    }
	
	    if (styleSheet && styleSheet.options.classNamePrefix) {
	      var _prefix = safePrefix(styleSheet.options.classNamePrefix);
	
	      return "".concat(_prefix, "-").concat(rule.key, "-").concat(ruleCounter);
	    }
	
	    return "".concat(rule.key, "-").concat(ruleCounter);
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(13));
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(10));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _objectSpread3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return (0, _objectSpread3.default)({
	        paddingLeft: spacing.unit * 2,
	        paddingRight: spacing.unit * 2
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _objectSpread3.default)({
	        paddingLeft: spacing.unit * 3,
	        paddingRight: spacing.unit * 3
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(46));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(242));
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(191));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(192));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(193));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(194));
	
	var _shadows = _interopRequireDefault(__webpack_require__(198));
	
	var _shape = _interopRequireDefault(__webpack_require__(199));
	
	var _spacing = _interopRequireDefault(__webpack_require__(200));
	
	var _transitions = _interopRequireDefault(__webpack_require__(201));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(202));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      shadowsInput = options.shadows,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var muiTheme = (0, _objectSpread2.default)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, _spacing.default, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Inject custom properties
	    shadows: shadowsInput || _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput)
	  }, (0, _deepmerge.default)({
	    shape: _shape.default,
	    spacing: _spacing.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other, {
	    isMergeableObject: _isPlainObject.default
	  }));
	   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(46));
	
	var _indigo = _interopRequireDefault(__webpack_require__(188));
	
	var _pink = _interopRequireDefault(__webpack_require__(189));
	
	var _grey = _interopRequireDefault(__webpack_require__(187));
	
	var _red = _interopRequireDefault(__webpack_require__(190));
	
	var _common = _interopRequireDefault(__webpack_require__(186));
	
	var _colorManipulator = __webpack_require__(135);
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.08)',
	    hoverOpacity: 0.08,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.14)',
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)'
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.1)',
	    hoverOpacity: 0.1,
	    selected: 'rgba(255, 255, 255, 0.2)',
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)'
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);
	
	  function getContrastText(background) {
	    // Use the same logic as
	    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
	    }
	
	    return contrastText;
	  }
	
	  function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	  }
	
	  augmentColor(primary);
	  augmentColor(secondary, 'A400', 'A200', 'A700');
	  augmentColor(error);
	  var types = {
	    dark: dark,
	    light: light
	  };
	   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
	  var paletteOutput = (0, _deepmerge.default)((0, _objectSpread2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: primary,
	    // The colors used to represent secondary interface elements for a user.
	    secondary: secondary,
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: error,
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between the background and
	    // the text.
	    contrastThreshold: contrastThreshold,
	    // Take a background color and return the color of the text to maximize the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other, {
	    clone: false // No need to clone deep
	
	  });
	  return paletteOutput;
	}

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(46));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "allVariants"]);
	
	  var coef = fontSize / 14;
	
	  function pxToRem(value) {
	    return "".concat(value / htmlFontSize * coef, "rem");
	  }
	
	  return (0, _deepmerge.default)({
	    pxToRem: pxToRem,
	    round: round,
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    display4: (0, _objectSpread2.default)({
	      fontSize: pxToRem(112),
	      fontWeight: fontWeightLight,
	      fontFamily: fontFamily,
	      letterSpacing: '-.04em',
	      lineHeight: "".concat(round(128 / 112), "em"),
	      marginLeft: '-.04em',
	      color: palette.text.secondary
	    }, allVariants),
	    display3: (0, _objectSpread2.default)({
	      fontSize: pxToRem(56),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      letterSpacing: '-.02em',
	      lineHeight: "".concat(round(73 / 56), "em"),
	      marginLeft: '-.02em',
	      color: palette.text.secondary
	    }, allVariants),
	    display2: (0, _objectSpread2.default)({
	      fontSize: pxToRem(45),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(51 / 45), "em"),
	      marginLeft: '-.02em',
	      color: palette.text.secondary
	    }, allVariants),
	    display1: (0, _objectSpread2.default)({
	      fontSize: pxToRem(34),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(41 / 34), "em"),
	      color: palette.text.secondary
	    }, allVariants),
	    headline: (0, _objectSpread2.default)({
	      fontSize: pxToRem(24),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(32.5 / 24), "em"),
	      color: palette.text.primary
	    }, allVariants),
	    title: (0, _objectSpread2.default)({
	      fontSize: pxToRem(21),
	      fontWeight: fontWeightMedium,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(24.5 / 21), "em"),
	      color: palette.text.primary
	    }, allVariants),
	    subheading: (0, _objectSpread2.default)({
	      fontSize: pxToRem(16),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(24 / 16), "em"),
	      color: palette.text.primary
	    }, allVariants),
	    body2: (0, _objectSpread2.default)({
	      fontSize: pxToRem(14),
	      fontWeight: fontWeightMedium,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(24 / 14), "em"),
	      color: palette.text.primary
	    }, allVariants),
	    body1: (0, _objectSpread2.default)({
	      fontSize: pxToRem(14),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(20.5 / 14), "em"),
	      color: palette.text.primary
	    }, allVariants),
	    caption: (0, _objectSpread2.default)({
	      fontSize: pxToRem(12),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: "".concat(round(16.5 / 12), "em"),
	      color: palette.text.secondary
	    }, allVariants),
	    button: (0, _objectSpread2.default)({
	      fontSize: pxToRem(14),
	      textTransform: 'uppercase',
	      fontWeight: fontWeightMedium,
	      fontFamily: fontFamily,
	      color: palette.text.primary
	    }, allVariants)
	  }, other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(57));
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(46));
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	// Support for the jss-expand plugin.
	function arrayMerge(destination, source) {
	  return source;
	}
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;
	
	  function create(theme, name) {
	    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	
	    if (!name || !theme.overrides || !theme.overrides[name]) {
	      return styles;
	    }
	
	    var overrides = theme.overrides[name];
	    var stylesWithOverrides = (0, _objectSpread2.default)({}, styles);
	    Object.keys(overrides).forEach(function (key) {
	       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
	      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
	        arrayMerge: arrayMerge
	      });
	    });
	    return stylesWithOverrides;
	  }
	
	  return {
	    create: create,
	    options: {},
	    themingEnabled: themingEnabled
	  };
	}
	
	var _default = getStylesCreator;
	exports.default = _default;

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name;
	
	  if (!name || !theme.props || !theme.props[name]) {
	    return {};
	  }
	
	  return theme.props[name];
	}
	
	var _default = getThemeProps;
	exports.default = _default;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _jssGlobal = _interopRequireDefault(__webpack_require__(246));
	
	var _jssNested = _interopRequireDefault(__webpack_require__(247));
	
	var _jssCamelCase = _interopRequireDefault(__webpack_require__(244));
	
	var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(245));
	
	var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(249));
	
	var _jssPropsSort = _interopRequireDefault(__webpack_require__(248));
	
	// Subset of jss-preset-default with only the plugins the Material-UI
	// components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
	  };
	}
	
	var _default = jssPreset;
	exports.default = _default;

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(73));
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component,
	      _options$noBase = options.noBase,
	      noBase = _options$noBase === void 0 ? false : _options$noBase;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  return (0, _objectSpread2.default)({}, baseClasses, Object.keys(newClasses).reduce(function (accumulator, key) {
	     false ? (0, _warning.default)(baseClasses[key] || noBase, ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _getDisplayName.default)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','))].join('\n')) : void 0;
	     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _getDisplayName.default)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;
	
	    if (newClasses[key]) {
	      accumulator[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	
	    return accumulator;
	  }, {}));
	}
	
	var _default = mergeClasses;
	exports.default = _default;

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
	}
	
	var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var spacing = {
	  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
	  // https://material.io/design/layout/understanding-layout.html#pixel-density
	  unit: 8
	};
	var _default = spacing;
	exports.default = _default;

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CHANNEL = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	// Same value used by react-jss
	var CHANNEL = '__THEMING__';
	exports.CHANNEL = CHANNEL;
	var themeListener = {
	  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, _propTypes.default.object),
	  initial: function initial(context) {
	    if (!context[CHANNEL]) {
	      return null;
	    }
	
	    return context[CHANNEL].getState();
	  },
	  subscribe: function subscribe(context, cb) {
	    if (!context[CHANNEL]) {
	      return null;
	    }
	
	    return context[CHANNEL].subscribe(cb);
	  },
	  unsubscribe: function unsubscribe(context, subscriptionId) {
	    if (context[CHANNEL]) {
	      context[CHANNEL].unsubscribe(subscriptionId);
	    }
	  }
	};
	var _default = themeListener;
	exports.default = _default;

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	/* eslint-disable no-param-reassign */
	
	/* eslint-disable no-restricted-globals */
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	var formatMs = function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	};
	
	exports.formatMs = formatMs;
	
	var isString = function isString(value) {
	  return typeof value === 'string';
	};
	
	exports.isString = isString;
	
	var isNumber = function isNumber(value) {
	  return !isNaN(parseFloat(value));
	};
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	exports.isNumber = isNumber;
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return function () {
	      var _options$duration = options.duration,
	          durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	          _options$easing = options.easing,
	          easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	          _options$delay = options.delay,
	          delay = _options$delay === void 0 ? 0 : _options$delay,
	          other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	       false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
	       false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
	       false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
	       false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
	       false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
	      return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	        return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	      }).join(',');
	    }();
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(134);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(15));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(10));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(20));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(21));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(87));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(73));
	
	var _wrapDisplayName = _interopRequireDefault(__webpack_require__(99));
	
	var _contextTypes = _interopRequireDefault(__webpack_require__(172));
	
	var _jss = __webpack_require__(117);
	
	var ns = _interopRequireWildcard(__webpack_require__(132));
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(137));
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(197));
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(101));
	
	var _themeListener = _interopRequireDefault(__webpack_require__(103));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(136));
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(195));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(196));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
	// We create the style sheet during at the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any childs styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	
	var indexCounter = -10e10; // Exported for test purposes
	
	var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.
	
	exports.sheetsManager = sheetsManager;
	var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.
	
	var defaultTheme;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme.default)();
	  return defaultTheme;
	} // Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	
	
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        _options$flip = options.flip,
	        flip = _options$flip === void 0 ? null : _options$flip,
	        name = options.name,
	        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
	    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';
	    indexCounter += 1;
	    stylesCreator.options.index = indexCounter;
	     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;
	
	    var WithStyles =
	    /*#__PURE__*/
	    function (_React$Component) {
	      (0, _inherits2.default)(WithStyles, _React$Component);
	
	      function WithStyles(props, context) {
	        var _this;
	
	        (0, _classCallCheck2.default)(this, WithStyles);
	        _this = (0, _possibleConstructorReturn2.default)(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));
	        _this.disableStylesGeneration = false;
	        _this.jss = null;
	        _this.sheetOptions = null;
	        _this.sheetsManager = sheetsManager;
	        _this.stylesCreatorSaved = null;
	        _this.theme = null;
	        _this.unsubscribeId = null;
	        _this.state = {};
	        _this.jss = _this.context[ns.jss] || jss;
	        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;
	
	        if (muiThemeProviderOptions) {
	          if (muiThemeProviderOptions.sheetsManager) {
	            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
	          }
	
	          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
	        } // Attach the stylesCreator to the instance of the component as in the context
	        // of react-hot-loader the hooks can be executed in a different closure context:
	        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107
	
	
	        _this.stylesCreatorSaved = stylesCreator;
	        _this.sheetOptions = (0, _objectSpread2.default)({
	          generateClassName: generateClassName
	        }, _this.context[ns.sheetOptions]); // We use || as the function call is lazy evaluated.
	
	        _this.theme = listenToTheme ? _themeListener.default.initial(context) || getDefaultTheme() : noopTheme;
	
	        _this.attach(_this.theme);
	
	        _this.cacheClasses = {
	          // Cache for the finalized classes value.
	          value: null,
	          // Cache for the last used classes prop pointer.
	          lastProp: null,
	          // Cache for the last used rendered classes pointer.
	          lastJSS: {}
	        };
	        return _this;
	      }
	
	      (0, _createClass2.default)(WithStyles, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          if (!listenToTheme) {
	            return;
	          }
	
	          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
	            var oldTheme = _this2.theme;
	            _this2.theme = theme;
	
	            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
	            // By theme update we mean receiving and applying the new class names.
	
	
	            _this2.setState({}, function () {
	              _this2.detach(oldTheme);
	            });
	          });
	        }
	      }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	          // react-hot-loader specific logic
	          if (this.stylesCreatorSaved === stylesCreator || ("production") === 'production') {
	            return;
	          }
	
	          this.detach(this.theme);
	          this.stylesCreatorSaved = stylesCreator;
	          this.attach(this.theme);
	          this.forceUpdate();
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          this.detach(this.theme);
	
	          if (this.unsubscribeId !== null) {
	            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
	          }
	        }
	      }, {
	        key: "getClasses",
	        value: function getClasses() {
	          // Tracks if either the rendered classes or classes prop has changed,
	          // requiring the generation of a new finalized classes object.
	          var generate = false;
	
	          if (!this.disableStylesGeneration) {
	            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
	            var sheetsManagerTheme = sheetManager.get(this.theme);
	
	            if (sheetsManagerTheme.sheet.classes !== this.cacheClasses.lastJSS) {
	              this.cacheClasses.lastJSS = sheetsManagerTheme.sheet.classes;
	              generate = true;
	            }
	          }
	
	          if (this.props.classes !== this.cacheClasses.lastProp) {
	            this.cacheClasses.lastProp = this.props.classes;
	            generate = true;
	          }
	
	          if (generate) {
	            this.cacheClasses.value = (0, _mergeClasses.default)({
	              baseClasses: this.cacheClasses.lastJSS,
	              newClasses: this.props.classes,
	              Component: Component,
	              noBase: this.disableStylesGeneration
	            });
	          }
	
	          return this.cacheClasses.value;
	        }
	      }, {
	        key: "attach",
	        value: function attach(theme) {
	          if (this.disableStylesGeneration) {
	            return;
	          }
	
	          var stylesCreatorSaved = this.stylesCreatorSaved;
	          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
	
	          if (!sheetManager) {
	            sheetManager = new Map();
	            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
	          }
	
	          var sheetManagerTheme = sheetManager.get(theme);
	
	          if (!sheetManagerTheme) {
	            sheetManagerTheme = {
	              refs: 0,
	              sheet: null
	            };
	            sheetManager.set(theme, sheetManagerTheme);
	          }
	
	          if (sheetManagerTheme.refs === 0) {
	            var styles = stylesCreatorSaved.create(theme, name);
	            var meta = name;
	
	            if (false) {
	              meta = (0, _getDisplayName.default)(Component);
	              process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
	            }
	
	            var sheet = this.jss.createStyleSheet(styles, (0, _objectSpread2.default)({
	              meta: meta,
	              classNamePrefix: meta,
	              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
	              link: false
	            }, this.sheetOptions, stylesCreatorSaved.options, {
	              name: name
	            }, styleSheetOptions));
	            sheetManagerTheme.sheet = sheet;
	            sheet.attach();
	            var sheetsRegistry = this.context[ns.sheetsRegistry];
	
	            if (sheetsRegistry) {
	              sheetsRegistry.add(sheet);
	            }
	          }
	
	          sheetManagerTheme.refs += 1;
	        }
	      }, {
	        key: "detach",
	        value: function detach(theme) {
	          if (this.disableStylesGeneration) {
	            return;
	          }
	
	          var stylesCreatorSaved = this.stylesCreatorSaved;
	          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
	          var sheetManagerTheme = sheetManager.get(theme);
	          sheetManagerTheme.refs -= 1;
	
	          if (sheetManagerTheme.refs === 0) {
	            sheetManager.delete(theme);
	            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
	            var sheetsRegistry = this.context[ns.sheetsRegistry];
	
	            if (sheetsRegistry) {
	              sheetsRegistry.remove(sheetManagerTheme.sheet);
	            }
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          var _props = this.props,
	              classes = _props.classes,
	              innerRef = _props.innerRef,
	              other = (0, _objectWithoutProperties2.default)(_props, ["classes", "innerRef"]);
	          var more = (0, _getThemeProps.default)({
	            theme: this.theme,
	            name: name
	          }); // Provide the theme to the wrapped component.
	          // So we don't have to use the `withTheme()` Higher-order Component.
	
	          if (withTheme) {
	            more.theme = this.theme;
	          }
	
	          return _react.default.createElement(Component, (0, _extends2.default)({}, more, {
	            classes: this.getClasses(),
	            ref: innerRef
	          }, other));
	        }
	      }]);
	      return WithStyles;
	    }(_react.default.Component);
	
	    WithStyles.propTypes =  false ? {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that property to pass a ref callback to the decorated component.
	       */
	      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
	    } : {};
	    WithStyles.contextTypes = (0, _objectSpread2.default)({
	      muiThemeProviderOptions: _propTypes.default.object
	    }, _contextTypes.default, listenToTheme ? _themeListener.default.contextTypes : {});
	
	    if (false) {
	      WithStyles.displayName = (0, _wrapDisplayName.default)(Component, 'WithStyles');
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, optionsArgument) {
		var clone = !optionsArgument || optionsArgument.clone !== false;
	
		return (clone && isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, optionsArgument)
			: value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, optionsArgument)
		})
	}
	
	function mergeObject(target, source, optionsArgument) {
		var destination = {};
		if (isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], optionsArgument);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], optionsArgument);
			} else {
				destination[key] = deepmerge(target[key], source[key], optionsArgument);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var options = optionsArgument || { arrayMerge: defaultArrayMerge };
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, optionsArgument)
		} else if (sourceIsArray) {
			var arrayMerge = options.arrayMerge || defaultArrayMerge;
			return arrayMerge(target, source, optionsArgument)
		} else {
			return mergeObject(target, source, optionsArgument)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, optionsArgument)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ }),

/***/ 656:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDisplayName = __webpack_require__(73);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PostHeader = __webpack_require__(532);
	
	var _PostHeader2 = _interopRequireDefault(_PostHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PostFooter = __webpack_require__(531);
	
	var _PostFooter2 = _interopRequireDefault(_PostFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Post = function Post(props) {
	  var post = props.post,
	      author = props.author,
	      slug = props.slug,
	      facebook = props.facebook;
	
	  var frontmatter = (post || {}).frontmatter;
	  var title = ((post || {}).frontmatter || {}).title;
	  var subTitle = ((post || {}).frontmatter || {}).subTitle;
	  var date = ((post || {}).fields || {}).prefix;
	  var html = (post || {}).html;
	  var htmlAst = (post || {}).htmlAst;
	
	  //console.log(htmlAst);
	  return _react2.default.createElement(
	    _Article2.default,
	    null,
	    _react2.default.createElement(_PostHeader2.default, { title: title, subTitle: subTitle, date: date }),
	    _react2.default.createElement(_Content2.default, { html: html }),
	    _react2.default.createElement(_PostFooter2.default, { author: author, post: post, slug: slug, facebook: facebook })
	  );
	};
	
	Post.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.object.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = Post;
	module.exports = exports["default"];

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _Avatar = __webpack_require__(180);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _config = __webpack_require__(43);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _avatar2 = __webpack_require__(175);
	
	var _avatar3 = _interopRequireDefault(_avatar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _author, _avatar;
	
	  return {
	    author: (_author = {
	      margin: "3em 0 0",
	      padding: "3em 0 0",
	      borderTop: "1px solid #ddd",
	      display: "flex",
	      flexDirection: "column",
	      alignItems: "center",
	      "& a": {
	        color: theme.base.colors.link
	      }
	    }, _author["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      flexDirection: "row",
	      justifyContent: "center"
	    }, _author),
	    avatar: (_avatar = {
	      margin: "0 1em 1em",
	      borderRadius: "75% 65%",
	      width: "60px",
	      height: "60px",
	      border: "1px solid #ddd",
	      flexShrink: 0
	    }, _avatar["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      margin: "0 1em 0"
	    }, _avatar),
	    box: {
	      display: "flex",
	      flexDirection: "column",
	      minHeight: "50px",
	      alignItems: "center"
	    }
	  };
	};
	
	var PostAuthor = function PostAuthor(props) {
	  var classes = props.classes,
	      author = props.author;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.author },
	    _react2.default.createElement(_Avatar2.default, { src: _avatar3.default, className: classes.avatar, alt: _config2.default.authorName }),
	    _react2.default.createElement("div", { className: classes.box, dangerouslySetInnerHTML: { __html: author.html } })
	  );
	};
	
	PostAuthor.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostAuthor);
	module.exports = exports["default"];

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _config = __webpack_require__(43);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(106);
	
	var styles = function styles(theme) {
	  return {
	    postComments: {
	      margin: "3em 0 0",
	      padding: "3em 0 0",
	      borderTop: "1px solid #ddd"
	    }
	  };
	};
	
	var PostComments = function PostComments(props) {
	  var classes = props.classes,
	      slug = props.slug,
	      facebook = props.facebook;
	
	
	  return _react2.default.createElement("div", null);
	};
	
	PostComments.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  post: _propTypes2.default.object.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostComments);
	module.exports = exports["default"];

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _AsyncComponent = __webpack_require__(207);
	
	var _AsyncComponent2 = _interopRequireDefault(_AsyncComponent);
	
	var _PostAuthor = __webpack_require__(529);
	
	var _PostAuthor2 = _interopRequireDefault(_PostAuthor);
	
	var _PostComments = __webpack_require__(530);
	
	var _PostComments2 = _interopRequireDefault(_PostComments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(106);
	
	var styles = function styles(theme) {
	  return {
	    footer: {
	      color: theme.main.colors.footer,
	      fontSize: theme.main.fonts.footer.size + "em",
	      lineHeight: theme.main.fonts.footer.lineHeight,
	      "& p": {
	        margin: 0
	      }
	    }
	  };
	};
	
	var PostShare = (0, _AsyncComponent2.default)(function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	      resolve(__webpack_require__(533));
	    });
	  }).then(function (module) {
	    return module;
	  }).catch(function (error) {});
	});
	
	var PostFooter = function PostFooter(_ref) {
	  var classes = _ref.classes,
	      author = _ref.author,
	      post = _ref.post,
	      slug = _ref.slug,
	      facebook = _ref.facebook;
	
	  return _react2.default.createElement(
	    "footer",
	    { className: classes.footer },
	    _react2.default.createElement(PostShare, { post: post, slug: slug }),
	    _react2.default.createElement(_PostComments2.default, { post: post, slug: slug, facebook: facebook })
	  );
	};
	
	PostFooter.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.object.isRequired,
	  post: _propTypes2.default.object.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostFooter);
	module.exports = exports["default"];

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _title, _subTitle;
	
	  return {
	    header: {
	      margin: "0 0 3em"
	    },
	    title: (_title = {
	      color: theme.main.colors.title,
	      fontSize: theme.main.fonts.title.size + "em",
	      letterSpacing: "-0.04em",
	      fontWeight: theme.main.fonts.title.weight,
	      lineHeight: theme.main.fonts.title.lineHeight,
	      margin: "0 0 0.4em"
	    }, _title["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      fontSize: theme.main.fonts.title.sizeM + "em"
	    }, _title["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      fontSize: theme.main.fonts.title.sizeL + "em",
	      letterSpacing: "-0.05em"
	    }, _title),
	    subTitle: (_subTitle = {
	      color: theme.main.colors.subTitle,
	      fontSize: theme.main.fonts.subTitle.size + "em",
	      lineHeight: theme.main.fonts.subTitle.lineHeight,
	      fontWeight: theme.main.fonts.subTitle.weight
	    }, _subTitle["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      fontSize: theme.main.fonts.subTitle.sizeM + "em"
	    }, _subTitle["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      fontSize: theme.main.fonts.subTitle.sizeL + "em"
	    }, _subTitle),
	    meta: {
	      fontSize: theme.main.fonts.meta.size + "em",
	      fontWeight: theme.main.fonts.meta.weight,
	      color: theme.main.colors.meta
	    }
	  };
	};
	
	var PostHeader = function PostHeader(props) {
	  var classes = props.classes,
	      title = props.title,
	      subTitle = props.subTitle,
	      date = props.date;
	
	
	  function myDate(dateString) {
	    var dateObj = new Date(dateString).toUTCString();
	    var dateToShow = dateObj.split(" ").slice(0, 4).join(" ");
	
	    return dateToShow;
	  }
	
	  return _react2.default.createElement(
	    "header",
	    { className: classes.header },
	    _react2.default.createElement(
	      "h1",
	      { className: classes.title },
	      title
	    ),
	    _react2.default.createElement(
	      "h2",
	      { className: classes.subTitle },
	      subTitle
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.meta },
	      myDate(date)
	    )
	  );
	};
	
	PostHeader.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  subTitle: _propTypes2.default.string,
	  date: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostHeader);
	module.exports = exports["default"];

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Post = __webpack_require__(528);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Post).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = asyncComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function asyncComponent(getComponent, loadingComponent) {
	  var AsyncComponent = function (_React$Component) {
	    _inherits(AsyncComponent, _React$Component);
	
	    function AsyncComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AsyncComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { Component: null }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    AsyncComponent.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.state.Component) {
	        getComponent().then(function (Component) {
	          _this2.setState({ Component: Component });
	        });
	      }
	    };
	
	    AsyncComponent.prototype.render = function render() {
	      var Component = this.state.Component;
	
	      if (Component) {
	        return _react2.default.createElement(Component, this.props);
	      }
	      return loadingComponent ? loadingComponent : _react2.default.createElement(
	        "div",
	        null,
	        "Loading..."
	      );
	    };
	
	    return AsyncComponent;
	  }(_react2.default.Component);
	
	  return AsyncComponent;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AsyncComponent = __webpack_require__(206);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AsyncComponent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avatar.07320eb0.jpg";

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _reactRedux = __webpack_require__(38);
	
	var _store = __webpack_require__(33);
	
	var _shared = __webpack_require__(58);
	
	var _Post = __webpack_require__(534);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Seo = __webpack_require__(76);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(106);
	__webpack_require__(656);
	
	var PostTemplate = function (_React$Component) {
	  _inherits(PostTemplate, _React$Component);
	
	  function PostTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PostTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.moveNavigatorAside = _shared.moveNavigatorAside.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PostTemplate.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.navigatorPosition === "is-featured") {
	      this.moveNavigatorAside();
	    }
	  };
	
	  PostTemplate.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathContext = _props.pathContext;
	
	    var facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
	    return _react2.default.createElement(
	      _Main2.default,
	      null,
	      _react2.default.createElement(_Post2.default, { post: data.post, slug: pathContext.slug, author: data.author, facebook: facebook }),
	      _react2.default.createElement(_Footer2.default, { footnote: data.footnote }),
	      _react2.default.createElement(_Seo2.default, { data: data.post, facebook: facebook })
	    );
	  };
	
	  return PostTemplate;
	}(_react2.default.Component);
	
	PostTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    isWideScreen: state.isWideScreen
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostTemplate);
	
	//eslint-disable-next-line no-undef
	
	var postQuery = exports.postQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-template-js-669994e2aaf526774390.js